export const addPeriodAfterOfferRolloverCopy = rolloverCopyString => {
  if (typeof rolloverCopyString !== 'string') return '';

  const rolloverCopyStringWithoutSpaces = rolloverCopyString.trim();
  const lastCharIsSpace = (rolloverCopyString.slice(-1) === ' ');
  let rolloverCopyStringFormatted = rolloverCopyString;

  if (lastCharIsSpace) {
    rolloverCopyStringFormatted = rolloverCopyStringWithoutSpaces;
  }

  const rolloverCopyStringLastChar = rolloverCopyStringFormatted.slice(-1);
  const missedPunctuationInRolloverCopy =
    rolloverCopyString && rolloverCopyStringLastChar !== '.' && rolloverCopyStringLastChar !== '!';

  const rolloverCopyStringWithPeriod = `${rolloverCopyString}. `;

  if (missedPunctuationInRolloverCopy) {
    return rolloverCopyStringWithPeriod;
  }

  return rolloverCopyStringFormatted;
};
